import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Reviews banner',
    },
  },
};


export function ReviewsHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="reviewshero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Reviews banner"
    >
      <InnerPageHeroSubtitle path="reviewshero.subtitle" />
      <RichTextContent
        path="reviewshero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken path="reviewshero.subtitle" type="richtext" as="span" className="hidden" style={{ display: 'none' }}>
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="reviewshero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'ReviewsHero',
  displayName: 'Reviews Hero',
  tokens: {
    'reviewshero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Reviews</p>',
    },
    'reviewshero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue: '<p>Resident Reviews in <span data-type="field-token" data-field="property_address_city"></span>, <span data-type="field-token" data-field="property_address_state"></span></p>',
    },
  },
  slotGroups: {
    'reviewshero.bg_image': bgImageDef,
  },
};

(ReviewsHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default ReviewsHero;
